/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Toolbar CSS
 */
export const styles = css`
  :host {
    display: block;
    width: 100%;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px;
    box-sizing: border-box;
    min-height: 64px;
    line-height: var(--nile-toolbar-line-height, var(--ng-line-height-text-xl));
    font-weight: var(--nile-toolbar-font-weight, var(--ng-font-weight-medium));
    font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
    font-size: var(--nile-toolbar-font-size, var(--ng-font-size-text-xl));
    background-color: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
    /* color: var(--nile-toolbar-text-color, var(--ng-color-base-black)); */  // TODO: Need to be tokenized in future.
  }
`;

export default [styles];
